var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pagination flex h30"
  }, [_c('div', {
    staticClass: "btn-responsive flex-pagination"
  }, [_c('div', {
    staticClass: "flex-pagination"
  }, [_c('span', [_vm._v("Go to")]), _c('span', {
    staticClass: "mb0 text-14",
    attrs: {
      "title": "enter go to page"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputPage,
      expression: "inputPage"
    }],
    staticClass: "btn-pagination",
    staticStyle: {
      "padding": "16px 4px",
      "outline": "none",
      "width": "50px",
      "font-size": "13px",
      "border-radius": "5px",
      "margin-right": "0px",
      "margin-top": "1px"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "5"
    },
    domProps: {
      "value": _vm.inputPage
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        _vm.goTo(Number(_vm.inputPage));
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.inputPage = $event.target.value;
      }
    }
  })])]), _c('div', {
    staticClass: "flex-pagination"
  }, [_c('span', {
    staticClass: "btn-pagination",
    staticStyle: {
      "width": "35px",
      "height": "35px",
      "background": "#f1f1f1",
      "border-radius": "4px"
    },
    attrs: {
      "title": "Previous"
    },
    on: {
      "click": function ($event) {
        _vm.goTo(Number(_vm.page) - 1);
      }
    }
  }, [_vm._v(" « ")]), _c('span', {
    staticClass: "text-14"
  }, [_vm._v(" Page " + _vm._s(_vm.page) + " of " + _vm._s(_vm.pagination) + " ")]), _c('span', {
    staticClass: "btn-pagination",
    staticStyle: {
      "width": "35px",
      "height": "35px",
      "background": "#f1f1f1",
      "border-radius": "4px"
    },
    attrs: {
      "title": "Next"
    },
    on: {
      "click": function ($event) {
        _vm.goTo(Number(_vm.page) + 1);
      }
    }
  }, [_vm._v(" » ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }